<template>
    <VBottomSheet ref="bts" v-model="value" :spaceTop="120" :scrollable="true" :persistent="true">
        <div class="relative -mt-20" v-if="open">
            <div class="px-6 pb-6 text-center">
                <section class="header">
                    <div>
                        <img :src="serialModel.campaignImgUrl" class="mx-auto rounded-15px campaign-img" alt />
                    </div>
                    <div class="text-primary mt-6">
                        {{serialModel.campaignName}}
                    </div>
                </section>
                <section class="mt-3 serial-tabs">
                    <VTabNav class="z-10" v-model="tab" :items="tabs" grow
                        @update:modelValue="setTracking($event)" fontSize="text-sm"></VTabNav>
                    <VTabItems id="tab-dialog-code" :tab="tab" class="pt-5">
                        <VTabItem>
                            <div class="flex flex-col w-full" 
                                v-if="tab == 0">
                                <div class="text-gray-secondary mb-3"
                                    v-html="privilegeMessage">
                                </div>
                                <div class="text-center mb-3">
                                    <VueQrcode class="mx-auto" :value="code" :options="{ width: 151 }"></VueQrcode>
                                </div>
                            </div>
                        </VTabItem>
                        <VTabItem>
                            <div class="flex flex-col w-full" 
                                v-if="tab == 1">
                                <div
                                    class="text-gray-secondary mb-3"
                                    v-html="privilegeMessage"
                                ></div>
                                <div class="mb-3">
                                    <div class="text-red-1 text-3xl break-all"
                                        :class="{'text-2xl': code.length > 12}">
                                        {{ code }}
                                    </div>
                                    <div class="mt-2 text-center">
                                        <button
                                            class="outline-none border border-primary rounded-full text-primary text-xs px-2 py-1"
                                            v-clipboard="code"
                                            v-clipboard:success="onCopySuccess"
                                            v-clipboard:error="onCopyError"
                                        >{{ lbl.serial.copy_code }}</button>
                                    </div>
                                </div>
                            </div>
                        </VTabItem>
                        <VTabItem>
                            <div class="flex flex-col w-full" 
                                v-if="tab == 2">
                                <div
                                    class="text-gray-secondary mb-3"
                                    v-html="privilegeMessage"
                                ></div>
                                <div class="text-center mb-3 flex justify-center overflow-hidden vue-barcode-container">
                                    <VueBarcode class="mx-auto" :value="code" :options="barcodeOption"></VueBarcode>
                                </div>
                            </div>
                        </VTabItem>
                    </VTabItems>
                </section>
                <section class="footer pb-8">
                    <SerialTimer :serialModel="serialModel" @onSerialExpired="onSerialExpired()"></SerialTimer>
                    <div class="text-gray-secondary my-3">{{ redeemOn }}</div>
                    <div class="mt-4">
                        <a class="underline text-primary" @click="onClickHistory()" v-if="isShowHistoryBtn">{{ lbl.serial.view_history }}</a>
                    </div>
                    <div class="mt-5">
                        <SlideToUseButton 
                            :text="lbl.confirm_used.slide_to_used"
                            :completedText="lbl.confirm_used.slide_to_used"
                            :autoReset="false"
                            @onSlideCompleted="onSlideToUse"/>
                        <div class="text-red-1 mt-1.5 text-base text-center">{{ slideToUseMessage }}</div>
                    </div>
                    <Footer :hasPoweredBy="hasPoweredBy" />
                </section>
            </div>
            <div class="absolute right-6 mt-20 top-6">
                <img src="@/assets/icon/dialog/close.svg" @click="clickClose()" class="w-18px h-18px" alt />
            </div>
        </div>
    </VBottomSheet>
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import VBottomSheet from "@/components/Dialog/BottomSheet.vue"
import VTabNav from "@/components/Tab/TabNav.vue"
import VTabItems from "@/components/Tab/TabItems.vue"
import VTabItem from "@/components/Tab/TabItem.vue"
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueBarcode from '@chenfengyuan/vue-barcode';
import SerialTimer from "./component/SerialTimer.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import SlideToUseButton from "@/components/Button/SlideToUseButton.vue"

export default {
    name: "SerialModal",
    mixins: [LocaleMixin],
    components: {
        VBottomSheet,
        VTabNav,
        VTabItems,
        VTabItem,
        VueQrcode,
        VueBarcode,
        SerialTimer,
        Footer,
        SlideToUseButton,
    },
    computed: {
        redeemOn: function () {
            if(this.serialModel.redeemTimestamp == "") return ""

            let dateStr = DatetimeHelper.getDatetimeFullByFormat(this.serialModel.redeemTimestamp, 'dd/MM/yy');
            return Util.stringFormat(this.lbl.serial.redeem_on, dateStr)
            // return Util.stringFormat(this.lbl.serial.redeem_on, "24/08/20")
        },
        tabs: function () {
            return [this.lbl.serial.qr_code, this.lbl.serial.code, this.lbl.serial.barcode];
        },
        slideToUseMessage: function () {
            return this.lbl.confirm_used.slide_to_used_message;
        },
        privilegeMessage: function () {
            if (this.serialModel.privilegeMessage != '' || this.serialModel.privilegeMessageEN != '') {
                return this.localeCode == 1054 ? this.serialModel.privilegeMessage : this.serialModel.privilegeMessageEN;
            }
            return this.lbl.serial.show_code_at_shop;
        }
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            value: false,
            hasPoweredBy: false,
            busModal: null,
            tab: 1,
            code: "",
            serialModel: null,
            trackingScreenName: 'hot_promotion_show_code',
            open: false,
            isShowHistoryBtn: true,
            barcodeOption: {
                height: 100,
                displayValue: false,
                lineColor: '#000000',
                width: 1,
            },
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
        // this.initialSerial();
    },
    beforeUnmount: function(){
        this.busModal.off('show')
        this.busModal.off('hide')
    },
    methods: {
        show: function(config) {
            this.tracking.screenName(this.trackingScreenName);
            this.serialModel = config.serialModel;
            this.isShowHistoryBtn = config.historyBtn;
            this.initialSerial();
            this.open = true;
            document.body.classList.add('not-scroll');
            this.$refs.bts.show()
            this.setTab();
        },
        hide: function() {
            this.open = false;
            document.body.classList.remove('not-scroll');
            this.$refs.bts.hide()
        },
        clickClose: function() {
            this.hide();
            this.controller.sendCloseModal();
        },

        getRedeemMessage: function () {
            let dateStr = DatetimeHelper.getDatetimeFullFormat(this.serialModel.redeemTimestamp);
            return Util.stringFormat(this.lbl.serial.redeem_on, dateStr);
        },

        initialSerial: function(){
            if (!this.serialModel.serial) {
                return;
            }
            this.code = this.serialModel.serial;
        },

        onSerialExpired: function() {
            this.code = "XXXXXXXX";
            this.controller.sendSerialExpire();
        },

        onClickHistory: function(){
            this.$router.push('/history');
        },

        onCopySuccess: function(e){
            var tracking_label = this.serialModel.campaignId + '|' + this.serialModel.campaignName + '|' + e.text;
            this.tracking.event('campaign_detail', 'click_copy_code', tracking_label, null);
        },
        onCopyError: function (e) {
            console.log('failed', e);
        },

        setTracking: function(selectedIndex){
            let trackCategory = 'campaign_detail';
            let trackAction = selectedIndex == 0 ? 'view_qr' : 'view_code';
            let tracking_label = this.serialModel.campaignId + '|' + this.serialModel.campaignName;
            this.tracking.event(trackCategory, trackAction, tracking_label, null);
        },

        setTab: function() {
            if (this.serialModel.serialType === "QR_CODE") {
                this.tab = 0;
            } else if (this.serialModel.serialType === "CODE_128") {
                this.tab = 2;
            } else { // CODE
                this.tab = 1;
            }
        },
        onSlideToUse: function() {
            this.controller.sendSlideToUsed();
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .modal {
        @extend %modal;

        .modal-content {
            overflow: unset;
            width: 420px;

            @include mobile {
                width: 100%;
                padding: 16px;
            }
        }
    }

    .campaign-img{
        width: 210px;
    }

    .vue-barcode-container {
        ::v-deep(svg), ::v-deep(img) {
            max-width: 100%;
            height: auto;
            object-fit: contain;
        }
    }
</style>
